import { AVATAR_RECIPE_VERSION } from "@/lib/drug-avatars/avatar-recipe"
import { avatarUriForDrug } from "@/lib/drug-avatars/avatar-cache"

/**
 * One procedural sphere per drug asset (FE-DRUG-AVATAR-1).
 *
 * Identity comes from the canonical asset ID. When no asset resolves, the
 * normalised name seeds an explicit fallback and the element is marked
 * data-identity="name" so the two cases stay distinguishable in the DOM.
 * There is deliberately no index prop: list position is never an identity.
 *
 * Server-safe: no hooks, no client directive. The asset-or-name rule and the
 * per-seed memo live in lib/drug-avatars/avatar-cache.ts; size is display only.
 */

export type DrugAvatarSize = 22 | 32 | 64

export function DrugAvatar({
  assetId,
  name,
  size,
  label,
  className,
}: {
  assetId: string | null
  name: string
  size: DrugAvatarSize
  label?: string
  className?: string
}) {
  const identity = assetId ? "asset" : "name"
  const src = avatarUriForDrug(assetId, name)
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={label ?? name}
      draggable={false}
      className={className}
      data-identity={identity}
      data-avatar-version={AVATAR_RECIPE_VERSION}
    />
  )
}
